import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'accounting_software/api/'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    downloadReportAcceptanceAct ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadReportAcceptanceAct'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report-acceptance-act/'
        const data = new FormData()
        data.append('period', payload.period + '-01')
        const download = require('js-file-download')
        session({ url: _url, method: 'POST', responseType: 'blob', data: data, headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            download(response.data,
              'Ежемесячный отчет по поступлению.xlsx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    downloadReportAccountingSoftwareList ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadReportAccountingSoftwareList'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report-accounting-software-list/'
        const data = new FormData()
        data.append('is_inventory', payload.is_inventory)
        const download = require('js-file-download')
        session({ url: _url, method: 'POST', responseType: 'blob', data: data, headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            download(response.data,
              'Список программ (инвитаризация).xlsx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    downloadReportFullAccountingSoftwareList ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadReportFullAccountingSoftwareList'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report-full-accounting-software-list/'
        const data = new FormData()
        data.append('is_inventory', payload.is_inventory)
        const download = require('js-file-download')
        session({ url: _url, method: 'POST', responseType: 'blob', data: data, headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            download(response.data,
              'Список программ (расширенный).xlsx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    downloadReportWriteOffAct ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadReportWriteOffAct'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report-write-off-act/'
        const data = new FormData()
        data.append('date_end', payload.date_end)
        const download = require('js-file-download')
        session({ url: _url, method: 'POST', responseType: 'blob', data: data, headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            download(response.data,
              'Акты на списание.docx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
  }
}
